var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleFileDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 8.5C8.9 6.8 10.3 5.4 12 5.4H22.3L31.1 14.2V31.5C31.1 33.2 29.7 34.6 28 34.6H12C10.3 34.6 8.9 33.2 8.9 31.5V8.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.6V11.4C22 13.1 23.4 14.5 25.1 14.5H30.9",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.5H25.5M14.5 26.5H25.5M14.5 16.5H18.5",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleFileDocIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_file_doc_icon.5cd36e46cb66ffdc7398e3131517f46a.svg";
export { ForwardRef as ReactComponent };